// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3xofx","select":"Header_select__2MUoB","clinic":"Header_clinic__2cXLT"};